import api from './api';

export const authService = {
  register: (data) => api.post('/auth/register/', data),
  login: (email, password, recaptcha_token) => api.post('/auth/login/', { email, password, recaptcha_token }),
  logout: (refresh) => api.post('/auth/logout/', { refresh }),
  getProfile: () => api.get('/auth/profile/'),
  updateProfile: (data) => api.patch('/auth/profile/', data, {
    headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {},
  }),
  changePassword: (data) => api.post('/auth/change-password/', data),
  verifyEmail: (otp) => api.post('/auth/verify-email/', { otp }),
  verifyPhone: (otp) => api.post('/auth/verify-phone/', { otp }),
  resendOTP: (type = 'email') => api.post('/auth/resend-otp/', { type }),
  requestPasswordReset: (email, recaptcha_token) => api.post('/auth/password-reset/', { email, recaptcha_token }),
  confirmPasswordReset: (data) => api.post('/auth/password-reset/confirm/', data),
  updateNotificationPreferences: (data) => api.patch('/auth/notification-preferences/', data),
  deactivateAccount: (password) => api.post('/auth/deactivate/', { password }),
};
